import React from 'react'
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues
} from 'react-hook-form'
import Select, { type SelectProps } from '~/components/Select'

export type FormSelectProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  name: TName
  control: Control<TFieldValues>
} & SelectProps

const FormSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  label,
  name,
  helperText,
  ...restSelectProps
}: FormSelectProps<TFieldValues, TName>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const { onChange, onBlur, value, ref } = field

        return (
          <Select
            value={value ?? ''}
            label={label}
            name={name}
            helperText={fieldState.error?.message ?? helperText}
            isError={Boolean(fieldState.error)}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
            data-testid={`${name}Select`}
            {...restSelectProps}
          />
        )
      }}
    />
  )
}

export default FormSelect
